import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface SelectOption {
  value: string;
  label: string;
}
interface SelectFieldProps {
  id: string;
  label: string;
  value: string;
  options: SelectOption[];
  onChange: (value: string) => void;
  hideLabel?: boolean;
  badge?: React.ReactNode;
}
export function SelectField({
  id,
  label,
  value,
  options,
  onChange,
  hideLabel = false,
  badge
}: SelectFieldProps) {
  return <div className="flex items-center gap-2" data-id="element-896" data-mp="2r34u5pdljumf">
      <label htmlFor={id} className={hideLabel ? 'sr-only' : 'whitespace-nowrap text-xs text-sf-weak'} data-id="element-897" data-mp="2m3rwsap3n55l">
        {label}
      </label>
      {badge}
      <div className="relative" data-id="element-898" data-mp="311ke98e7i3mf">
        <select id={id} value={value} onChange={event => onChange(event.target.value)} className="h-8 appearance-none rounded border border-sf-border-strong bg-white pl-3 pr-8 text-[13px] text-sf-text focus:border-sf-blue focus:outline-none focus:ring-1 focus:ring-sf-blue" data-id="element-899" data-mp="30yg0bjaxvtik">
          {options.map(option => <option key={option.value} value={option.value} data-id="element-900" data-mp="1k239q4xqtc05">
              {option.label}
            </option>)}
        </select>
        <ChevronDownIcon className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-sf-weak" aria-hidden="true" data-id="element-901" data-mp="1u0stk39796j1" />
      </div>
    </div>;
}